import { Box, Stack } from '@chakra-ui/react';
import React from 'react';
import Image from '../Image';
import StyledLink from '../StyledLink';
import Text from '../Text';
import { formatProgramThumbnailTitle } from './utils';

var ProgramThumbnal = function ProgramThumbnal(props) {
  var bg = props.bg,
      city = props.city,
      country = props.country,
      image = props.image,
      uri = props.uri,
      title = props.title,
      description = props.description;
  var formattedTitle = title ? title : formatProgramThumbnailTitle({
    city: city,
    country: country
  });
  return /*#__PURE__*/React.createElement(StyledLink, {
    to: uri,
    width: "300px"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Image, {
    display: "flex",
    image: image
  }), /*#__PURE__*/React.createElement(Stack, {
    align: "center",
    justify: "center",
    spacing: 0,
    bg: bg,
    height: "80px",
    px: 3,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    textTransform: "uppercase",
    fontWeight: "900"
  }, formattedTitle), /*#__PURE__*/React.createElement(Text, {
    lineHeight: 1
  }, description))));
};

export default ProgramThumbnal;